import { API_PATH_PUSH_NOTIFICATION, API } from '../../helpers/api';
import { useAPICallAsync } from './useAPICallAsync';
export var usePushNotification = function (checkSelectedGrant) {
    var _a = useAPICallAsync({
        api: {
            method: 'POST',
            endpoint: API_PATH_PUSH_NOTIFICATION,
        },
        baseRoute: API,
        checkSelectedGrant: checkSelectedGrant,
    }), result = _a.result, call = _a.call;
    return {
        result: result,
        call: call,
    };
};
//# sourceMappingURL=usePushNotification.js.map